"use client";

import { useRef } from "react";
import { toast } from "sonner";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Nationalsearchcta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const commandRef = useRef<HTMLDivElement>(null);
  const installCommand = "Book your free SEO consultation today";
  const handleCopyCommand = async () => {
    try {
      await navigator.clipboard.writeText("Book your free SEO consultation today");
      toast.success("Consultation link copied", {
        description: installCommand
      });
    } catch {
      toast.error("Unable to copy link");
    }
  };
  return <section data-section-id="18651" id="nationalsearchcta" className="bg-background text-foreground relative overflow-hidden py-28 md:py-40 px-6 md:px-12 border-t-2 border-b-2 border-border">
      <div className="max-w-[1320px] mx-auto">
        <div ref={ref} className={`max-w-[960px] mx-auto text-center transition-all duration-[380ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="font-default text-[0.875rem] font-semibold uppercase text-muted-foreground mb-10" style={{
          letterSpacing: "0.14em",
          lineHeight: 1
        }}>
            {"NATIONAL SEARCH STRATEGY \u00B7 FREE CONSULTATION"}
          </div>

          <h2 className="font-default font-extrabold text-foreground" style={{
          fontSize: "clamp(2.25rem, 4.5vw, 3.75rem)",
          letterSpacing: "-0.03em",
          lineHeight: 0.92
        }}>
            Ready to grow your <span className="text-primary">national search visibility</span>?
          </h2>

          <p className="font-default font-normal text-muted-foreground mx-auto mt-12" style={{
          fontSize: "clamp(1.1875rem, 1.25vw, 1.4rem)",
          letterSpacing: "-0.005em",
          lineHeight: 1.55,
          maxWidth: "56ch"
        }}>
            Book your free SEO consultation today to speak directly with me. I will review your current national search visibility, identify high-impact technical opportunities, and outline a bespoke strategy to grow your organic traffic nationwide.
          </p>

          <div className="mt-14 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-5">
            <Link to="/ContactPage" className="inline-block">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 border-2 border-primary font-default font-semibold w-full sm:w-auto px-10 py-6 h-auto text-base rounded-md transition-all duration-140 ease-out hover:translate-x-[2px] hover:translate-y-[2px] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none" style={{
              fontSize: "1.25rem",
              boxShadow: "4px 4px 0 0 hsl(220 80% 30%)"
            }}>
                Book a Free SEO Consultation
              </Button>
            </Link>

            <Link to="/SeoAuditsPage" className="inline-block">
              <Button variant="outline" className="bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-default font-semibold w-full sm:w-auto px-10 py-6 h-auto text-base rounded-md transition-colors duration-180" style={{
              fontSize: "1.25rem"
            }}>
                Get a Free SEO Audit
              </Button>
            </Link>
          </div>

          <div className="mt-16 flex justify-center">
            <div ref={commandRef} onClick={handleCopyCommand} onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleCopyCommand();
            }
          }} role="button" tabIndex={0} aria-label="Copy consultation link" className="inline-block border-2 border-border px-4 py-2 cursor-pointer rounded-md font-mono text-muted-foreground hover:text-primary hover:border-primary transition-colors duration-200 select-none" style={{
            fontSize: "0.9375rem",
            letterSpacing: 0,
            lineHeight: 1.4
          }}>
              {installCommand}
            </div>
          </div>
        </div>
      </div>

      <Toaster position="bottom-right" />
    </section>;
}